import { wxProxyUrl } from '@/config/wx.config'
import { map } from 'lodash'

const FollowWechatUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU4NTg2OTM2Mw==#wechat_redirect'
// 重定向到指定地址，并附带code参数
function redirect ({ redirectTo, appId }) {
  const baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
  const query = {
    'appid': appId,
    'redirect_uri': process.env.NODE_ENV === 'development' ? `${wxProxyUrl}${encodeURIComponent(redirectTo)}` : redirectTo,
    'response_type': 'code',
    'scope': 'snsapi_userinfo'
    // 'state': state // 可以传递一些自定义参数
    // 'connect_redirect': 1 // 好像每什么用
  }
  const hash = '#wechat_redirect'
  const location = (() => {
    const queryString = map(query, (value, name) => `${name}=${encodeURIComponent(value)}`).join('&')
    return baseUrl + '?' + queryString + hash
  })()
  window.location = location
}

// 判断当前浏览器是否是微信浏览器
function isWechatBrowser () {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 跳出微信支付
function onBridgeReady (getBrandWCPayRequest) {
  if (isWechatBrowser() && getBrandWCPayRequest) {
    /*global WeixinJSBridge*/
    return new Promise((resolve, reject) => {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        getBrandWCPayRequest,
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            resolve('成功')
          } else {
            // get_brand_wcpay_request:cancel 或者 get_brand_wcpay_request:fail 可以统一处理为用户遇到错误或者主动放弃。
            reject('失败')
          }
        }
      )
    })
  }
}

const isIOS = () => {
  const isIphone = navigator.userAgent.includes('iPhone')
  const isIpad = navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}

export {
  isIOS,
  redirect,
  isWechatBrowser,
  FollowWechatUrl,
  onBridgeReady
}

